'use strict';

var helper = require('../helper');

module.exports = {
    // 6.116 REFUND OPTION - MOTIVATION SELECT
    pushRefundOptionMotivationSelect (motivation, position, sku) {
        if (!motivation || !position || !sku) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '115',
            'eventname': 'return',
            'step': 'motivation_select',
            'text': motivation,
            'position': position,
            'product_id': sku
        };
        helper.log('Pushing refund option motivation select interaction!', true);
        helper.push(pushObject);
    },

    // 6.117 REFUND OPTION - SHIPPING METHOD
    pushRefundOptionShippingMethod (shippingMethod, position, skus) {
        if (!shippingMethod || !position || !skus) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '41',
            'eventname': 'return',
            'step': 'shipping_select',
            'shipping_method': shippingMethod,
            'position': position,
            'product_id': skus
        };
        helper.log('Pushing refund option shipping method interaction!', true);
        helper.push(pushObject);
    },

    // 6.118 REFUND OPTION - PAYMENT METHOD
    pushRefundOptionPaymentMethod (paymentMethod, position, skus) {
        if (!paymentMethod || !position || !skus) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '116',
            'eventname': 'return',
            'step': 'payment_select',
            'payment_method': paymentMethod,
            'position': position,
            'product_id': skus

        };
        helper.log('Pushing refund option payment method interaction!', true);
        helper.push(pushObject);
    },

    pushRefundOptionConfirmation (skus, position, shippingMethod, paymentMethod, transactionID) {
        if (!skus || !position || !shippingMethod || !paymentMethod) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '117',
            'eventname': 'return_confirmation',
            'step': 'confirmation',
            'order': transactionID,
            'product_id': skus,
            'position': position,
            'shipping_method': shippingMethod,
            'payment_method': paymentMethod
        };
        helper.log('Pushing refund option confirmation interaction!', true);
        helper.push(pushObject);
    },

    // 7.160 PRODUCT EXCHANGE OPTION-START
    pushExchangeOptionSelect (touchpoint, motivation) {
        if (!touchpoint) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '167',
            'eventname': 'product_exchange',
            'step': 'start',
            'position': touchpoint,
            'text': motivation
        };
        helper.log('Pushing refund option motivation select interaction!', true);
        helper.push(pushObject);
    },

    // 7.161 PRODUCT EXCHANGE OPTION - MOTIVATION SELECT
    pushExchangeProductOption (change, sku, touchpoint) {
        if (!change || !sku || !touchpoint) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '168',
            'eventname': 'product_exchange',
            'step': 'change_selection',
            'type': change,
            'product_id': sku,
            'position': touchpoint,
        };
        helper.log('Pushing refund option motivation select interaction!', true);
        helper.push(pushObject);
    },

    // 7.162 PRODUCT EXCHANGE OPTION - SHIPPING METHOD
    pushExchangeOptionShippingMethod (shippingMethod, touchpoint, skus) {
        if (!shippingMethod || !touchpoint || !skus) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '169',
            'eventname': 'product_exchange',
            'step': 'shipping_select',
            'shipping_method': shippingMethod,
            'position': touchpoint,
            'product_id': skus
        };
        helper.log('Pushing refund option shipping method interaction!', true);
        helper.push(pushObject);
    },
};
